import React from "react";
import { CheckBox, NumberBox } from "devextreme-react";

const MandatoryPasswordChange = ({ onValueChange, value }) => {
  return (
    <div className='mb-5'>
      <table className='table table-bordered align-middle mt-1'>
        <thead className='table-dark'>
          <tr>
            <th scope='col'>Setting</th>
            <th scope='col'>Value</th>
            <th scope='col'>Explanation</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope='row'>
              Users are required to regularly change their passwords
            </th>
            <td className='text-center' style={{ width: "40%" }}>
              <CheckBox
                value={value.rotate_passwords_enabled}
                onValueChanged={(e) =>
                  onValueChange(e, "rotate_passwords_enabled")
                }
              />
            </td>
            <td style={{ width: "30%" }}>
              If you enable this policy, neither users nor API integrations will
              be able to authenticate with an expired password. User groups can
              be exempted from the requirement. It is recommended to create a
              separate user group for API integrations and turn off the
              requirement for that group.
            </td>
          </tr>
          <tr>
            <th scope='row'>Password change interval in days</th>
            <td className='text-center' style={{ width: "40%" }}>
              <NumberBox
                min={1}
                value={value.rotate_passwords_days}
                onValueChanged={(e) =>
                  onValueChange(e, "rotate_passwords_days")
                }
              />
            </td>
            <td style={{ width: "30%" }}></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default MandatoryPasswordChange;
